export const LABELS_DIRECTIVE_INIT_SUFFIX = 'LabelsDirectiveInit';

export const SESSION_EVENT = {
  userProfileUpdate: 'adn.event:user-profile-update'
};

